import { START_LOADING, END_LOADING, GET_PRICES } from "../type";

const initState = {
  isLoading: false,
  productPrices: {}
};

export default function(state = initState, action) {
  const { type, payload } = action;

  switch (type) {
    case START_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case GET_PRICES:
      return {
        ...state,
        productPrices: payload,
        isLoading: false
      };
    case END_LOADING:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
}
